import React, { createContext, useContext, useState, ReactNode } from 'react';
import { MIN_DRAWER_WIDTH } from './constants';

interface DrawerContextType {
    open: boolean;
    setOpen: (prev: boolean) => void;
    toggleDrawer: () => void;
    drawerWidth: number;
    setDrawerWidth: (width: number) => void;
}

const DrawerContext = createContext<DrawerContextType | undefined>(undefined);

export const DrawerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [drawerWidth, setDrawerWidth] = useState(MIN_DRAWER_WIDTH);

    const toggleDrawer = () => {
        setOpen(prev => !prev);
    };

    return <DrawerContext.Provider value={{ open, setOpen, toggleDrawer, drawerWidth, setDrawerWidth }}>{children}</DrawerContext.Provider>;
};

export const useDrawer = () => {
    const context = useContext(DrawerContext);
    if (!context) {
        throw new Error('useDrawer must be used within a DrawerProvider');
    }
    return context;
};
